// Framework

window.colorValue = function (str) {
    var ctx = document.createElement('canvas').getContext('2d');
    ctx.fillStyle = str;
    return ctx.fillStyle;
}

window.parseBool = function (b) {
    if (b == null) return false;
    // return !(/^(false|no|0)$/i).test(b) && !!b;
    // r = ( typeof( b) == "boolean") ? b : truethis.test( b);
    r = (typeof (b) == "boolean") ? b : /^\s*(true|yes|1|T|Y|on)\s*$/gi.test(b);
    // console.log( "Received: " + b + " evaluated as: " + (r ? "True" : "False"));
    // for( x = 0; x < b.length; x++ ) { console.log( b.charCodeAt( x)); }
    return (r);
};

var UI_VERSION = "1.28.0"

var INET = "INET";
var INET_GLOBAL = "Global";
var INET_LOCAL = "Local";

// Appliction Events
var E_DATERANGECHANGE = "DateRangeChange";            // Issued whenever a new date range is selected
var E_THEMECHANGE = "ThemeChange";
var E_PREREFRESH = "Prerefresh";
var E_REFRESH = "Refresh";
var E_SETREFRESH = "SetRefresh";
var E_SETAUTOREFRESH = "SetAutoRefresh";
var E_POSTREFRESH = "Postrefresh";
var E_RESIZE = "Resize";
var E_REDRAW = "Redraw";
var E_MAINMENU = "MainMenu";
var E_LOADMENU = "LoadMenu";                    // Indicates that the Main Menu should reload itself
var E_MENUOPEN = "MenuOpen";                   // Indicates the Main menu should open now
var E_MENUCLOSE = "MenuClose";                  // Indicates the Main menu should close now
var E_MENUOPENING = "MenuOpening";                // Fired when the Main menu starts opening
var E_MENUCLOSING = "MenuClosing";                // Fired when the Main menu starts closing
var E_MENUOPENED = "MenuOpened";                 // Fired when the Main menu finishes opening
var E_MENUCLOSED = "MenuClosed";                 // Fired when the Main menu finishes closing
var E_LOCK = "Lock/*";                   // Generic Lock event (typically lock window)
var E_LOGOUT = "Logout/*";                   // Generic Logout encompassing all logout reasons
var E_USERLOGOUT = "Logout/User";                // User initiated logout
var E_FORCELOGOUT = "Logout/Force";               // User's session has expired, Tokens won't Renew, or Server instructs a Logout
var E_JUMP = "Jump";                       // Jump to another page
var E_INITIALIZED = "Initialized";
var E_CREATED = "Created";
var E_GETDATA = "GetData";
var E_GETMOREINFO = "GetMoreInfo";
var E_ACTION = "Action";
var E_DATA = "Data";
var E_PRINT = "Print";
var E_REMOVE = "Remove";
var E_EXPORT = "Export";
var E_NOTICE = "Notice";
var E_MORE = "More";
var E_EXPANDDETAIL = "ExandDetail";
var E_COLLAPSEDETAIL = "CollapseDetail";
var E_SETTINGSCHANGE = "SettingChange";
var E_NEWALERT = "NewAlert";
var E_PLANTLIST = "NewPlantList";
var E_PLANTSELECTED = "PlantSelected";
var E_PLANTDETAIL = "PlantDetail";
var E_INCOMPLETE = "Access/Incomplete";
var E_ILLEGAL = "Access/Illegal";
var E_FAILURE = "Access/Failure";
var E_ERROR = "Access/Error";
var E_INVALID = "Access/Invalid";
var E_SUCCESS = "Access/Success";
var E_BLOB = "Access/Blob";
var E_TIMEOUT = "Access/Timeout";
var E_ACCESS_EXPIRED = "Access/Expired";
var E_ACCESS_REFRESH = "Access/Refresh";
var E_ACCESS = "Access/*";
var E_BREADCRUMB = "Breadcrumb/*";
var E_BREADCRUMBADD = "Breadcrumb/Add";
var E_BREADCRUMBDEL = "Breadcrumb/Remove";
var E_BREADCRUMBSET = "Breadcrumb/Set";
var E_NOTICESAVAILABLE = "Notices/Available";
var E_CHANGEPWD = "Password/Change";
var E_CARADDED = "Data/Update/AddCar";
var E_CUSTOMERINFOCHANGE = "CustomerInfoChange";
var E_EVENT = "Event"
var E_EDITBRC = "BRC/Edit";
const E_CARS_IN_INSPECTION = "Cars/InInspection"; // This is used to load the cars in inspection page
const E_USER_GROUP_SELECTION = "Usergroup/Edit";
const E_USER_GROUPS_LOADED = "Usergroup/Loaded";
const E_USER_PROFILE_VIEW = "UserProfile/View";
const E_USER_JS_NOTIFIER = "UserProfile/Loaded";
const E_CR_BILL_PART_VIEW = "CRBillParts/View";
const E_CR_BILL_PART_SEARCH_FORM_LOADED = "CRBillParts/SearchFormLoaded";
const E_CR_BILL_PRICE_MASTER_DATA_LOADED = "CRBillPriceMaster/DataLoaded";
const E_CR_BILL_PRICE_MASTER_VIEW = "CRBillPriceMaster/View";
const E_CR_BILL_AGREEMENT_DATA_LOADED = "CRBillAgreement/DataLoaded";
const E_CR_BILL_AGREEMENT_VIEW = "CRBillAgreement/View";
const E_CR_BILL_CLIENT_DATA_LOADED = "CRBillClient/DataLoaded";
const E_CR_BILL_CLIENT_VIEW = "CRBillClient/View";
const E_PLANT_MGMT_DATA_LOADED = "PlantMgmt/DataLoaded";
const E_PLANT_MGMT_VIEW = "PlantMgmt/View";
const E_CR_BILL_PART_CHANGE = "CRBillPart/Change";
const E_CR_BILL_CUSTOMER_CHANGE = "CRBillCustomer/Change";
const E_CR_BILL_CLIENT_PRICE_MASTER_CHANGE = "CRBillClientPriceMaster/Change";
const E_AUDIT_RULES_TRANSLATION_DATA_LOADED = "CRBillAuditRule/TranslationsLoaded";
const E_AUDIT_RULES_TRANSLATION_VIEW = "CRBillAuditRule/TranslationView";

// Page-specific events
var E_VISITS_SEARCH = "Visits/Search";
var E_CARMASTER_SEARCH = "CarMaster/Search";
const E_CARMASTER_SEARCH_FORM_LOADED = "CarMaster/SearchFormLoaded"
var E_OWNED_SEARCH = "Owned/Search";
var E_PLANTMGMT_SEARCH = "Plantmgmt/Search";
var E_USERMGMT_LOAD_CUSTOMER = "Usermgmt/Search";

// Scope
var G_GLOBAL = INET + "/" + INET_GLOBAL + "/";
var L_LOCAL = INET + "/" + INET_LOCAL + "/";

// Global Events
var G_DATERANGECHANGE = G_GLOBAL + E_DATERANGECHANGE;
var G_THEMECHANGE = G_GLOBAL + E_THEMECHANGE;
var G_PREREFRESH = G_GLOBAL + E_PREREFRESH;
var G_REFRESH = G_GLOBAL + E_REFRESH;
var G_SETREFRESH = G_GLOBAL + E_SETREFRESH;
var G_SETAUTOREFRESH = G_GLOBAL + E_SETAUTOREFRESH;
var G_POSTREFRESH = G_GLOBAL + E_POSTREFRESH;
var G_RESIZE = G_GLOBAL + E_RESIZE;
var G_MENUOPEN = G_GLOBAL + E_MENUOPEN;
var G_MENUCLOSE = G_GLOBAL + E_MENUCLOSE;
var G_MENUOPENING = G_GLOBAL + E_MENUOPENING;
var G_MENUCLOSING = G_GLOBAL + E_MENUCLOSING;
var G_MENUOPENED = G_GLOBAL + E_MENUOPENED;
var G_MENUCLOSED = G_GLOBAL + E_MENUCLOSED;
var G_LOCK = G_GLOBAL + E_LOCK;
var G_LOGOUT = G_GLOBAL + E_LOGOUT;
var G_USERLOGOUT = G_GLOBAL + E_USERLOGOUT;
var G_FORCELOGOUT = G_GLOBAL + E_FORCELOGOUT;
var G_MAINMENU = G_GLOBAL + E_MAINMENU;
var G_LOADMENU = G_GLOBAL + E_LOADMENU;
var G_JUMP = G_GLOBAL + E_JUMP;
var G_GETDATA = G_GLOBAL + E_GETDATA;
var G_DATA = G_GLOBAL + E_DATA;
var G_CREATED = G_GLOBAL + E_CREATED;
var G_INITIALIZED = G_GLOBAL + E_INITIALIZED;
var G_SETTINGSCHANGE = G_GLOBAL + E_SETTINGSCHANGE;
var G_ACTION = G_GLOBAL + E_ACTION;
var G_NOTICE = G_GLOBAL + E_NOTICE;
var G_NEW_ALERT = G_GLOBAL + E_NEWALERT;
var G_GETMOREINFO = G_GLOBAL + E_GETMOREINFO;
var G_PLANTLIST = G_GLOBAL + E_PLANTLIST;
var G_PLANTSELECTED = G_GLOBAL + E_PLANTSELECTED;
var G_PLANTDETAIL = G_GLOBAL + E_PLANTDETAIL;
var G_ACCESS_INCOMPLETE = G_GLOBAL + E_INCOMPLETE;
var G_ACCESS_ILLEGAL = G_GLOBAL + E_ILLEGAL;
var G_ACCESS_FAILURE = G_GLOBAL + E_FAILURE;
var G_ACCESS_ERROR = G_GLOBAL + E_ERROR;
var G_ACCESS_INVALID = G_GLOBAL + E_INVALID;
var G_ACCESS_SUCCESS = G_GLOBAL + E_SUCCESS;
var G_ACCESS_BLOB = G_GLOBAL + E_BLOB;
var G_ACCESS_TIMEOUT = G_GLOBAL + E_TIMEOUT;
var G_ACCESS_EXPIRED = G_GLOBAL + E_ACCESS_EXPIRED;
var G_ACCESS_REFRESH = G_GLOBAL + E_ACCESS_REFRESH;
var G_ACCESS = G_GLOBAL + E_ACCESS;
var G_BREADCRUMB = G_GLOBAL + E_BREADCRUMB;
var G_BREADCRUMBADD = G_GLOBAL + E_BREADCRUMBADD;
var G_BREADCRUMBDEL = G_GLOBAL + E_BREADCRUMBDEL;
var G_BREADCRUMBSET = G_GLOBAL + E_BREADCRUMBSET;
var G_NOTICESAVAILABLE = G_GLOBAL + E_NOTICESAVAILABLE;
var G_CHANGEPWD = G_GLOBAL + E_CHANGEPWD;
var G_CARADDED = G_GLOBAL + E_CARADDED;
var G_EVENT = G_GLOBAL + E_EVENT;
var G_EDITBRC = G_GLOBAL + E_EDITBRC;

var G_CUSTOMERINFOCHANGE = G_GLOBAL + E_CUSTOMERINFOCHANGE;
// Local Events
var L_VISITS_SEARCH = L_LOCAL + E_VISITS_SEARCH;
var L_CAR_MASTER_SEARCH = L_LOCAL + E_CARMASTER_SEARCH;
const L_CARMASTER_SEARCH_FORM_LOADED = L_LOCAL + E_CARMASTER_SEARCH_FORM_LOADED;
const L_CARS_IN_INSPECTION = L_LOCAL + E_CARS_IN_INSPECTION;
const L_USER_GROUP_LOADED = L_LOCAL + E_USER_GROUPS_LOADED;
const L_USER_GROUP_EDIT = L_LOCAL + E_USER_GROUP_SELECTION;
const L_USER_PROFILE_VIEW = L_LOCAL + E_USER_PROFILE_VIEW;
const L_USER_JS_LOADER_NOTIFIER = L_LOCAL + E_USER_JS_NOTIFIER;
var L_OWNED_SEARCH = L_LOCAL + E_OWNED_SEARCH;
var L_PLANTMGMT_SEARCH = L_LOCAL + E_PLANTMGMT_SEARCH;
var L_USERMGMT_LOAD_CUSTOMER = L_LOCAL + E_USERMGMT_LOAD_CUSTOMER;
const L_CR_BILL_PART_VIEW = L_LOCAL + E_CR_BILL_PART_VIEW;
const L_CR_BILL_PART_SEARCH_FORM_LOADED = L_LOCAL + E_CR_BILL_PART_SEARCH_FORM_LOADED;
const L_CR_BILL_PRICE_MASTER_DATA_LOADED = L_LOCAL + E_CR_BILL_PRICE_MASTER_DATA_LOADED;
const L_CR_BILL_PRICE_MASTER_VIEW = L_LOCAL + E_CR_BILL_PRICE_MASTER_VIEW;
const L_CR_BILL_AGREEMENT_DATA_LOADED = L_LOCAL + E_CR_BILL_AGREEMENT_DATA_LOADED;
const L_CR_BILL_AGREEMENT_VIEW = L_LOCAL + E_CR_BILL_AGREEMENT_VIEW;
const L_CR_BILL_CLIENT_DATA_LOADED = L_LOCAL + E_CR_BILL_CLIENT_DATA_LOADED;
const L_CR_BILL_CLIENT_VIEW = L_LOCAL + E_CR_BILL_CLIENT_VIEW;
const L_PLANT_MGMT_DATA_LOADED = L_LOCAL + E_PLANT_MGMT_DATA_LOADED;
const L_PLANT_MGMT_VIEW = L_LOCAL + E_PLANT_MGMT_VIEW;
const L_CR_BILL_PART_CHANGE = L_LOCAL + E_CR_BILL_PART_CHANGE;
const L_CR_BILL_CUSTOMER_CHANGE = L_LOCAL + E_CR_BILL_CUSTOMER_CHANGE;
const L_CR_BILL_CLIENT_PRICE_MASTER_CHANGE = L_LOCAL + E_CR_BILL_CLIENT_PRICE_MASTER_CHANGE;
const L_AUDIT_RULES_TRANSLATION_DATA_LOADED = L_LOCAL + E_AUDIT_RULES_TRANSLATION_DATA_LOADED;
const L_AUDIT_RULES_TRANSLATION_VIEW = L_LOCAL + E_AUDIT_RULES_TRANSLATION_VIEW;


var MAP_DEFAULT_LONGITUDE = -99.447515
var MAP_DEFAULT_LATITUDE = 38.491395
var MAP_DEFAULT_WORLD_ZOOM = 10 //4
var MAP_DEFAULT_PLANT_ZOOM = 17.6

var MOVE_LINE_COLOR = colorValue("black");
var MOVE_LINE_WEIGHT = 3

var CARS_STROKE_COLOR = "#00731b"         // In JS can do 'rgba(200, 100, 240, 0.4)',
var CARS_FILL_COLOR = "#fd7e14"
var CARS_STROKE_OPACITY = 1
var CARS_FILL_OPACITY = 0.8
var CARS_EXTRUSION_OPACITY = 0.8
var CARS_STROKE_WEIGHT = 3

var ALARM_STROKE_COLOR = "#D80000"
var ALARM_FILL_COLOR = "#D80000"
var ALARM_STROKE_OPACITY = 1
var ALARM_FILL_OPACITY = 0.8
var ALARM_EXTRUSION_OPACITY = 0.5
var ALARM_STROKE_WEIGHT = 3

var SPOTS_STROKE_COLOR = "#3297c9"
var SPOTS_FILL_COLOR = "#3297c9"
var SPOTS_STROKE_OPACITY = 0.6
var SPOTS_FILL_OPACITY = 0.3
var SPOTS_STROKE_WEIGHT = 3

var STACK_FILL_COLOR = "#00FF00"

var SWITCH_STROKE_COLOR = colorValue("yellow")
var SWITCH_FILL_COLOR = "#3297c9"
var SWITCH_STROKE_OPACITY = 0.6
var SWITCH_FILL_OPACITY = 0.1
var SWITCH_STROKE_WEIGHT = 3

var SMRT_ANCHOR_COLOR = "#39FF14"
var SMRT_HUB_COLOR = "#00C5FF"

var ALLOWED_PHOTO_FORMATS = '.png,.jpg,.jpeg,.gif'
var ALLOWED_VIDEO_FORMATS = '.mp4,.m4a,.mov,.webm,.avi,.wmv'
var ALLOWED_DOCUMENT_FORMATS = '.pdf,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx,.txt,.mp3'
var ALLOWED_DMS_FORMATS = '.txt,.pdf,.png,.jpg,.jpeg,.gif,.mp4,.m4a,.mov,.pdf,.docx,.pptx,.xlsx,.doc,.xls,.csv,.txt,.mp3,.mp4,.mov,.avi,.wmv,.webm,.png,.jpg,.jpeg,.gif'
var ALLOWED_TABULAR_FORMATS = '.csv,.xls,.xlsx'

var LEFT_TOGGLE_SVG = 'path://M 11.00,12.00 C 11.00,13.66 9.66,15.00 8.00,15.00 6.34,15.00 5.00,13.66 5.00,12.00 5.00,10.34 6.34,9.00 8.00,9.00 9.66,9.00 11.00,10.34 11.00,12.00 Z M 16.00,5.00 C 19.87,5.00 23.00,8.13 23.00,12.00 23.00,12.00 23.00,12.00 23.00,12.00 23.00,15.87 19.87,19.00 16.00,19.00 16.00,19.00 8.00,19.00 8.00,19.00 4.13,19.00 1.00,15.87 1.00,12.00 1.00,12.00 1.00,12.00 1.00,12.00 1.00,8.13 4.13,5.00 8.00,5.00 8.00,5.00 16.00,5.00 16.00,5.00 Z'
var RIGHT_TOGGLE_SVG = 'path://M 19.00,12.00 C 19.00,13.66 17.66,15.00 16.00,15.00 14.34,15.00 13.00,13.66 13.00,12.00 13.00,10.34 14.34,9.00 16.00,9.00 17.66,9.00 19.00,10.34 19.00,12.00 Z M 16.00,5.00 C 19.87,5.00 23.00,8.13 23.00,12.00 23.00,12.00 23.00,12.00 23.00,12.00 23.00,15.87 19.87,19.00 16.00,19.00 16.00,19.00 8.00,19.00 8.00,19.00 4.13,19.00 1.00,15.87 1.00,12.00 1.00,12.00 1.00,12.00 1.00,12.00 1.00,8.13 4.13,5.00 8.00,5.00 8.00,5.00 16.00,5.00 16.00,5.00 Z'
var FILE_TEXT_SVG = 'path://M 10.00,9.00 C 10.00,9.00 9.00,9.00 9.00,9.00 9.00,9.00 8.00,9.00 8.00,9.00M 16.00,17.00 C 16.00,17.00 8.00,17.00 8.00,17.00M 16.00,13.00 C 16.00,13.00 8.00,13.00 8.00,13.00M 14.00,2.00 C 14.00,2.00 14.00,8.00 14.00,8.00 14.00,8.00 20.00,8.00 20.00,8.00M 14.00,2.00 C 14.00,2.00 6.00,2.00 6.00,2.00 4.90,2.00 4.00,2.90 4.00,4.00 4.00,4.00 4.00,20.00 4.00,20.00 4.00,21.10 4.90,22.00 6.00,22.00 6.00,22.00 18.00,22.00 18.00,22.00 19.10,22.00 20.00,21.10 20.00,20.00 20.00,20.00 20.00,8.00 20.00,8.00 20.00,8.00 14.00,2.00 14.00,2.00 Z'
var INFO_ICON_SVG  = 'path://M 24.00,16.00C 24.00,16.00 24.02,20 24.02,20M 24.00,32.00C 24.00,32.00 24.00,24.00 24.00,24.00M 44.00,24.00C 44.00,35.05 35.05,44.00 24.00,44.00  12.95,44.00 4.00,35.05 4.00,24.00  4.00,12.95 12.95,4.00 24.00,4.00  35.05,4.00 44.00,12.95 44.00,24.00 Z'

// BRC Blade Specific Constants
var BRC_STEEL_JOB_CODES       = ["4202", "4204"];
var BRC_WHEEL_JOB_CODE_MIN    = 3001;
var BRC_WHEEL_JOB_CODE_MAX    = 3151;
var CURRENCY_SYMBOL_MAP = [
  { code: 'USD', symbol: '$',   name: 'US Dollar'       },
  { code: 'CAD', symbol: 'CA$', name: 'Canadian Dollar' },
];

var G = {};                 // Init some Global App Variables

G.dc = [];
//G.ps = PubSub.newInstance();
G.ps = PubSub;
G.eventQueue = {}

G.filter =
{
    "plant_id": 0,
    "startTime": 0,
    "endTime": 0,
    "yard_id": 0,
    "track_id": 0
}

G.apiVersion = 1
G.apiPath = "/api/v" + G.apiVersion;
G.request = "";         // Last returned data set

//-----

G.pagename = "";                            // The name of the SPA page that is currently topmost
G.plant_list = {};                          // The most recently retrieved list of plants the user has access to
G.plant_info = {};                          // Details of the currently selected plant
G.maps = {};                                // Object to contain references to all Leaflet maps
G.pages = {};                               // Object to store page-related information in
// G.accessToken = false;
// G.refreshToken = false;
G.translations = {}
G.preferences =
{
    "show_create_new": "No",
    "show_quick_menu": "No",
    "show_global_search": "No",
    "show_alert_bell": "Yes",
    "enable_support_chat": "Yes",
    "show_inspection_state_bar": "No",
    "show_support_chat": "Yes"
}
G.messages = false;
